<template>
  <div class="wrapper">
    <div class="container p-0">
      <div class="header">
        <div class="logo">
          <img src="../assets/theme/header.png">
        </div>
      </div>
    </div>

    <div class="container main-bg p-0">
      <div class="main">
        <div class="content">
          <div class="l-content">
            <!-- <div class="l-bolck">
              <div class="banner banner-bottom">
                <img src="../assets/banner/b1.png">
              </div>
            </div> -->
            <TodayResult />
            <div class="l-bolck">
              <div class="banner banner-bottom">
                <img src="../assets/banner/b2.png">
              </div>
              <div class="banner banner-bottom mt-2">
                <img src="../assets/banner/b3.png">
              </div>
              <!-- <div class="banner banner-bottom mt-2">
                <img src="../assets/banner/b4.png">
              </div> -->
            </div>
          </div>
          <div class="r-content">
            <HistoryResults />
          </div>
        </div>

        <div class="bottom-banner">
          <img src="../assets/banner/b5.png">
        </div>

        <div class="footer">
          <div class="footer-inner">
            Copyright ©{{year}} - laosantipap.com
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TodayResult from './components/TodayResult.vue'
import HistoryResults from './components/HistoryResults.vue'
import moment from '@/moment'

export default {
  components: {
    TodayResult,
    HistoryResults
  },
  data() {
    return {
      year: moment().format("YYYY")
    }
  }
}
</script>
<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

.wrapper {
  padding: 0;
  background-color: #222;
  margin-right: auto;
  margin-left: auto;
}

.footer {
  margin-top: 0px;

  .footer-inner {
    text-align: center;
    padding: 15px;
    color: #FFF;
  }
}

.container {
  max-width: 1100px;

  .header {
    border-bottom: 1px solid #eee;

    .logo {
      img {
        width: 100%;
      }
    }
  }

  &.main-bg {
    background-image: url('../assets/theme/bg.png');
    background-position: bottom center;
    background-size: 100% auto;
    background-color: #900000;
    background-repeat: no-repeat;
  }

  .main {
    width: 1050px;
    max-width: 100%;
    margin: 0 auto;

    .content {
      padding-top: 10px;
      display: flex;

      .l-content {
        width: 440px;

        .l-bolck {
          margin-bottom: 10px;

          .banner {
            img {
              width: 100%;
              max-width: 100%;
            }
          }
        }
      }
      .r-content {
        width: calc(100% - 450px);
        margin-left: 10px;

        .banner {
          margin-bottom: 10px;
          img {
            width: 100%;
            max-width: 100%;
          }
        }
      }
    }

    .bottom-banner {
      img {
        width: 100%;
      }
    }
  }
}

@media only screen and (max-width:991px) {
  .container {
    .main {
      .header {
        height: 150px;

        .logo {
          padding-left: 20px;

          img {
            height: 130px;
          }
        }
      }

      .content {
        flex-direction: column;

        .l-content {
          width: 100%;
        }

        .r-content {
          width: 100%;
          margin-left: 0;
        }
      }
    }
  }
}

@media only screen and (max-width:767px) {
  .container {
    .main {
      .header {
        height: 120px;

        .logo {
          padding-left: 20px;

          img {
            height: 100px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width:575px) {
  .container .main .content .l-content {
    padding: 0 5px;
  }

  .container .main .content .r-content {
    padding: 0 5px;
  }
}

@media only screen and (max-width:460px) {
  .container {
    .main {
      .header {
        height: 100px;

        .logo {
          padding-left: 10px;

          img {
            height: 90px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width:399px) {
  .container {
    .main {
      .header {
        height: 80px;

        .logo {
          padding-left: 10px;

          img {
            height: 70px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width:350px) {
  .container {
    .main {
      .header {
        height: 70px;

        .logo {
          padding-left: 10px;

          img {
            height: 60px;
          }
        }
      }
    }
  }

  .now-result .result-head h2 {
    font-size: 1.2rem;
  }

  .now-result .result-body .result-top h1 {
    font-size: 3.5rem;

    span {
      padding: 0 4px;
    }
  }

  .history-results .his-head-bg h2 {
    font-size: 1.2rem;
  }
}
</style>
